import React from "react";
import { Badge } from "../../../shared/components/Badge.jsx";
import { rupees } from "../../../shared/components/tableColumns.jsx";

export const isLowStock = (item) => item.itemType !== "service" && Number(item.stock) <= Number(item.reorderLevel || 10);

/** Desktop table columns for the Items list; row click edits, the last column deletes. */
export function itemColumns({ onDelete }) {
  return [
    {
      key: "itemName",
      label: "Item",
      sortValue: (item) => item.itemName || item.name || "",
      render: (item) => <strong>{item.itemType === "service" ? "⚙️" : "📦"} {item.itemName || item.name}</strong>
    },
    { key: "gstCode", label: "HSN / SAC", width: 120, render: (item) => item.gstCode || <span className="text-dim">—</span> },
    {
      key: "itemType",
      label: "Type",
      width: 100,
      optional: true,
      sortValue: (item) => (item.itemType === "service" ? "Service" : "Goods"),
      render: (item) => (item.itemType === "service" ? "Service" : "Goods")
    },
    { key: "gstPercent", label: "GST", width: 80, align: "right", sortValue: (item) => Number(item.gstPercent || 0), render: (item) => `${item.gstPercent || 0}%` },
    {
      key: "stock",
      label: "Stock",
      width: 130,
      align: "right",
      sortValue: (item) => (item.itemType === "service" ? null : Number(item.stock || 0)),
      render: (item) => {
        if (item.itemType === "service") return <span className="text-dim">—</span>;
        const label = `${item.stock} ${item.unit || "pcs"}`;
        return isLowStock(item) ? <Badge variant="danger">{label}</Badge> : label;
      }
    },
    {
      key: "basicPrice",
      label: "Price",
      width: 125,
      align: "right",
      className: "amount",
      sortValue: (item) => Number(item.basicPrice || item.sellingPrice || 0),
      render: (item) => rupees(item.basicPrice || item.sellingPrice)
    },
    {
      key: "costPrice",
      label: "Cost",
      width: 115,
      align: "right",
      optional: true,
      className: "amount",
      sortValue: (item) => Number(item.costPrice || 0),
      render: (item) => (Number(item.costPrice || 0) > 0 ? rupees(item.costPrice) : <span className="text-dim">—</span>)
    },
    {
      key: "actions",
      label: "",
      width: 60,
      noSort: true,
      align: "right",
      render: (item) => (
        <button
          type="button"
          className="btn-icon table-action danger"
          title="Delete item"
          aria-label={`Delete ${item.itemName || item.name}`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(item);
          }}
        >
          🗑️
        </button>
      )
    }
  ];
}
